module.exports = __webpack_public_path__ + "static/media/success_icon.3cac2f22.svg";